import { render } from "./TournamentsPage.vue?vue&type=template&id=e89f8c00&ts=true"
import script from "./TournamentsPage.vue?vue&type=script&lang=ts"
export * from "./TournamentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Tournaments/TournamentsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e89f8c00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e89f8c00', __exports__)) {
    api.reload('e89f8c00', __exports__)
  }
  
  module.hot.accept("./TournamentsPage.vue?vue&type=template&id=e89f8c00&ts=true", () => {
    api.rerender('e89f8c00', render)
  })

}


export default __exports__